

























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'ConversationDetailHtmlEventVersionViewer',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    stylizedHtmlDescriptionLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
})
